export default __webpack_public_path__ + "images/VKO .bf5f881.png";